/* import __COLOCATED_TEMPLATE__ from './sq-field-date-buttons.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from '@ember/component';
/**
 * SqFieldDateButtons works as a calendar dropdown with optional date quick-select buttons
 *
 *
 * ```example
 * @title Simple Example
 * @hbs
 * <SqFieldDateButtons
 *   @dateButtons={{this.dateButtons}}
 *   @disabledDateRange={{this.disabledDateRange}}
 *   @dropdownPlacement={{this.dropdownPlacement}}
 *   @triggerLabel={{this.triggerLabel}}
 *   @value={{this.value}}
 *   @onChange={{action "onChange"}}
 * />
 * ```
 *
 * ### Parameters
 * @param {Date} value - the date being edited
 * @param {String} [triggerLabel] - dropdown trigger label text
 * @param {Object} [disabledDateRange] - range of values not selectable in the calendar
 * @param {String} [dropdownPlacement] - controls dropdown placement, defaults to 'bottom-start'
 * @param {Array} [dateButtons] - configuration for date buttons, each item should have `date` and `label` properties
 * @param {Action} onChange - action called when user selects a new date
 **/

export default class SqFieldDateButtons extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "dropdownPlacement", 'bottom-start');
  }
}